module.exports = __webpack_public_path__ + "static/img/RAC166_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAC166_1.png
// module id = TcLp
// module chunks = 0